import { LiveblocksProvider } from '@liveblocks/react'
import { PropsWithChildren } from 'react'

import type { CommentsUserMeta } from './types'

type CommentsLiveblocksProviderProps = PropsWithChildren<{
  authEndpoint: () => Promise<{ token: string }>
  resolveUsers: (args: {
    userIds: readonly string[]
  }) => Promise<(CommentsUserMeta['info'] | undefined)[]>
  resolveMentionSuggestions: (args: { text: string }) => Promise<string[]>
}>

export const CommentsLiveblocksProvider = ({
  authEndpoint,
  resolveUsers,
  resolveMentionSuggestions,
  children,
}: CommentsLiveblocksProviderProps) => (
  <LiveblocksProvider
    preventUnsavedChanges
    authEndpoint={authEndpoint}
    resolveUsers={resolveUsers}
    resolveMentionSuggestions={resolveMentionSuggestions}
  >
    {children}
  </LiveblocksProvider>
)
